/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayify } from '@gh/core-util';
import { CheckboxTreeNode } from './checkbox-tree-node';

export function normalizeNode<T>(node: CheckboxTreeNode<T>): void {
  if (node.children && node.children.length) {
    node.checked = node.children.some((child) => child.checked);
    node.indeterminate = node.checked
      ? node.children.some((child) => (!child.checked || child.indeterminate === true))
      : false;
  } else {
    node.indeterminate = false;
  }
}

export function forEachNode<T>(root: CheckboxTreeNode<T> | CheckboxTreeNode<T>[],
                               procedureFn: ProcedureFn<CheckboxTreeNode<T>>): void {
  const parents: CheckboxTreeNode<T>[] = [];
  const traversed: CheckboxTreeNode<T>[] = [];

  arrayify(root).forEach((node: CheckboxTreeNode<T>) => parents.push(node));

  while (parents.length) {
    const parent = parents.pop();

    if (!parent) {
      break;
    }

    if (parent.children) {
      traversed.push(parent);
      parent.children.forEach((child) => parents.push(child));
    } else {
      traversed.push(parent);
    }
  }

  while (traversed.length) {
    const node = traversed.pop();

    if (node) {
      procedureFn(node);
    }
  }
}
